import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

import API_URL from "../config/config";
import "../css/admin.css";
import AdminSidebar from "../components/AdminSidebar";

import {
  FaUsers,
  FaBoxOpen,
  FaShoppingCart,
  FaRupeeSign
} from "react-icons/fa";

function AdminDashboard() {

  const navigate = useNavigate();

  const [dashboard, setDashboard] = useState({
    totalUsers: 0,
    totalProducts: 0,
    totalOrders: 0,
    revenue: 0
  });

  useEffect(() => {

    const role = localStorage.getItem("role");

    if (role !== "admin") {

      alert("Access Denied");

      navigate("/");

      return;

    }

axios
  .get(`${API_URL}/admin/dashboard`, {
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  })
  .then((res) => {
    setDashboard(res.data);
  })
  .catch((err) => {
    console.log(err);
  });

  }, [navigate]);

  return (

    <div className="admin-layout">

      <AdminSidebar />

      <div className="admin-content">

        <h1 className="admin-title">
          Admin Dashboard
        </h1>

        <div className="dashboard-grid">

          <div className="dashboard-card">
            <FaUsers className="dashboard-icon" />
            <h2>{dashboard.totalUsers}</h2>
            <p>Total Users</p>
          </div>

          <div className="dashboard-card">
            <FaBoxOpen className="dashboard-icon" />
            <h2>{dashboard.totalProducts}</h2>
            <p>Total Products</p>
          </div>

          <div className="dashboard-card">
            <FaShoppingCart className="dashboard-icon" />
            <h2>{dashboard.totalOrders}</h2>
            <p>Total Orders</p>
          </div>

          <div className="dashboard-card">
            <FaRupeeSign className="dashboard-icon" />
            <h2>₹{dashboard.revenue}</h2>
            <p>Total Revenue</p>
          </div>

        </div>

      </div>

    </div>

  );

}

export default AdminDashboard;